<template>
  

    <div class="grid">
      <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
      <div class="col-12">
        <div class="card">
          <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
                <template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href"  @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                    <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                    <span class="text-color">{{ item.label }}</span>
                </a>
                </template>
            </Breadcrumb>
          <Toast />
              <div class="p-fluid formgrid grid" style="margin-top: 2%">          
                <div class="field col-12 md:col-2">
                  <span class="p-float-label">                
                    <Dropdown
                      id="state" 
                      filter                     
                      v-model="vehicle_search"  
                      :options="vehicle_dropdown" 
                      :value="vehicle_dropdown.id"
                      optionLabel="name" 
                      >
                    </Dropdown>
                  <label for="client">Select Vehicle</label>
                </span>
                </div>

                <div class="field col-12 md:col-2">
                    <span class="p-float-label">
                        <Dropdown                                            
                            id="status"
                            v-model="search_status"
                            :options="status_dropdown"
                            :value="status_dropdown"
                            optionLabel="name"
                            filter
                        ></Dropdown>
                        <label for="status">Status</label>
                    </span>
                </div>
                    
                <div class="field col-12 md:col-2">
                  <Button
                    style="background-color: #349CE4; border: 1px solid #349CE4;"
                    icon="pi pi-search"
                    @click="search(1)"
                    v-tooltip.bottom="'Search'"
                  />
                </div>
                <!-- <div class="field col-12 md:col-6 justify-end text-right">
                  <Button                   
                      icon="pi pi-plus"
                      v-tooltip.bottom="'Add'"
                      @click="openNew"
                    /> &nbsp; 
                  <json-excel :data="product">
                  <Button                
                    icon="pi pi-upload"
                    v-tooltip.bottom="'Export'"
                  @click="exportCSV"
                  />
                  </json-excel>
                </div> -->
              </div>
        
          <DataTable
            :loading="loading"
            ref="dt"
            :lazy="true"
            :totalRecords="totalRecords"
            :paginator="true"
            :value="products"
            v-model:selection="selectedProducts"
            :dataKey="columns[0]"
            :rows="limit"
            :filters="filters"
            @page="onPage($event)"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25, totalRecords]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            responsiveLayout="scroll"
            style="font-size: 12px"
            :rowHover="true" showGridlines
          >
          <template #empty>
          <b style="text-align:center">No records found.</b>
        </template>
            <template #header>
              <div
                class="
                  flex flex-column
                  md:flex-row md:justify-content-between md:align-items-center
                "
              >
                <h5 class="m-0"><b> Vehicle Device Mapping List</b></h5>
                
                <div>
                  <Button 
                    style="background-color: #349CE4; border: 1px solid #349CE4;"              
                    class="mr-2" 
                    icon="pi pi-refresh" 
                    @click="search(2)"   
                    v-tooltip.bottom="'Refresh'"
                  />                
                  <Button
                      style="background-color: #349CE4; border: 1px solid #349CE4;" 
                      class="mr-2"                  
                      icon="pi pi-plus"
                      v-tooltip.bottom="'Add'"
                      @click="openNew"
                    /> 
                  <json-excel :data="product">
                  <Button  
                    style="background-color: #349CE4; border: 1px solid #349CE4;"
                    class="mr-2"              
                    icon="pi pi-upload"
                    v-tooltip.bottom="'Export'"
                  @click="exportCSV"
                  />
                  </json-excel>
                </div>
              </div>
              
              <div style="text-align:right;font-weight:bold;margin-top: 1%;">
                <span>Total Records:</span>{{totalRecords}}
              </div>

            </template>
            <Column header="Status" style="min-width: 8rem ;text-align: center;" :field="columns[9]" >
              <template #body="{ data }"> 
                <span v-if="data.status=='Active' ||data.status=='active'"><badge :value=data.status severity="success"></badge></span>
              <span v-else-if="data.status=='InActive' ||data.status=='In Active'"><badge :value=data.status severity="warning"></badge></span>
              <span v-else-if="data.status=='Delete' ||data.status=='Deleted'"><badge :value=data.status severity="danger"></badge></span>
              <span v-else>-</span>
              </template>
            </Column>
  
            <Column header="Sr No" style="min-width: 5rem;text-align: center;">
              <template #body="{ index}">
              <span v-if="page_no==1">{{ +index+ +1 }}</span>
                <span v-else>{{(+index+1)+limit*(page_no-1)}}</span>
              </template>
            </Column>

            <Column header="User Name" :field="columns[16]" style="text-align:center;">
              <template #body="{ data }">
                {{ data.user_name }}
              </template>
            </Column>

            <Column header="User Mobile" :field="columns[17]" style="text-align:center;">
              <template #body="{ data }">
                {{ data.user_mobile }}
              </template>
            </Column>

            <Column header="Vehicle Number" :field="columns[18]" style="text-align:center;">
              <template #body="{ data }">
                {{ data.vehicle_num }}
              </template>
            </Column>
             
            <Column header="Beacon Identifier" :field="columns[2]" style="text-align:center;">
              <template #body="{ data }">
                {{ data.beaconIndentifier }}
              </template>
            </Column>                      
            
            <Column header="Beacon MAC ID" :field="columns[3]" style="min-width: 10rem">
              <template #body="{ data }">
                <span v-if=" data.beaconMacId">{{data.beaconMacId}}</span>
                <span v-else>-</span>                
              </template>
            </Column>

            <Column header="Beacon Accuracy" :field="columns[10]" style="min-width: 5rem">
              <template #body="{ data }">
                <span v-if=" data.beaconAccuracy">{{data.beaconAccuracy}}</span>
                <span v-else>-</span>
              </template>
            </Column>

            <Column header="Beacon Major" :field="columns[11]">
              <template #body="{ data }">
               <span v-if=" data.beaconMajor">{{data.beaconMajor}}</span>
                <span v-else>-</span>
              </template>
            </Column>
           
            <Column header="Beacon Minor" :field="columns[12]">
              <template #body="{ data }">
                <span v-if=" data.beaconMinor">{{data.beaconMinor}}</span>
                <span v-else>-</span>
              </template>
            </Column>

            <Column header="Beacon RSSI" style="min-width: 5rem" :field="columns[14]">
              <template #body="{ data }">
                {{ data.beaconRssi }}
              </template>
            </Column> 

            <Column header="Beacon Power" style="min-width: 5rem" :field="columns[15]">
              <template #body="{ data }">
                {{ data.beacontXPower }}
              </template>
            </Column> 
          
            <Column header="Action" headerStyle="min-width:10rem;">
              <template #body="slotProps">
                <!-- <Button
                  icon="pi pi-map-marker"
                  v-tooltip.bottom="'Route Map'"
                  class="p-button-rounded p-button-primary mr-2"
                  @click="view_Map(slotProps.data)"
                />
                <Button
                  icon="pi pi-eye"
                  v-tooltip.bottom="'View'"
                  class="p-button-rounded p-button-success mr-2"
                  @click="viewProduct(slotProps.data)"
                /> -->
                <Button
                  icon="pi pi-pencil"
                  title="Edit Route"
                  v-tooltip.bottom="'Edit'"
                  class="p-button-rounded p-button-warning mr-2"
                  @click="editProduct(slotProps.data)"
                />
                
                <Button
                  icon="pi pi-trash"
                  v-tooltip.bottom="'Delete'"
                  class="p-button-rounded p-button-danger mt-2"
                  @click="confirmDeleteProduct(slotProps.data)"
                />
              </template>
            </Column>
          </DataTable>
          <Sidebar
            v-model:visible="map_productDialog"
            :baseZIndex="1000"
            position="full"
          >
          <div class="col-12">
              <div class="card">
                <GoogleMap api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc" style="width: 100%; height: 500px" :center="start_point" :zoom="7" >
                  <Marker  :options="{ position: start_point }">
                  </Marker>

                  <Marker  :options="{ position: end_point }">
                  </Marker>

                  <MarkerCluster>
                    <Marker :options="{ position: marker,title: 'stop',label: marker.stop_name,color:'green',icon:'http://maps.google.com/mapfiles/ms/icons/green-dot.png' }"   v-for="(marker, index) in markers" style="width:5px;height:5px">
                    </Marker>
                  </MarkerCluster>
    
                  <Polyline   :options="flightPath" />
                </GoogleMap>
              </div>
          </div>
          </Sidebar>
  
          <Sidebar
            v-model:visible="productDialog"
            :baseZIndex="1000"
            position="full"
            @hide="reset"
          >
            <div class="col-12">
              <div class="card">
                <h5>Beacon Form</h5>
                <hr />
                <div class="p-fluid formgrid grid">                
  
                  <div class="field col-12 md:col-6">
                    <label for="name">Beacon UUID</label>
                    <InputText
                      id="name"
                      type="text"
                      v-model.trim="product.beaconUUID"
                      required="true"                      
                    />
                  </div>

                  <div class="field col-12 md:col-2">
                    <label for="status">Status</label>
                    <Dropdown
                      id="status"
                      v-model="selectedstatus"
                      :options="status_dropdown"
                      :value="status_dropdown.value"
                      optionLabel="name"
                      placeholder="Select One"
                      :class="{ 'p-invalid': submitted && !selectedstatus }"
                      required="true"
                    ></Dropdown>
                  </div>

                  <div class="field col-12 md:col-2">
                    <label for="beaconIndentifier">Beacon Identifier</label>
                    <InputText
                      id="beaconIndentifier"
                      type="text"
                      v-model.trim="product.beaconIndentifier"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.beaconIndentifier }"
                    />
                  </div>

                  <div class="field col-12 md:col-2">
                    <label for="city">Beacon Accuracy</label>
                    <InputText
                      id="beaconAccuracy"
                      type="text"
                      v-model.trim="product.beaconAccuracy"
                      required="true"
                      autofocus
                    />
                  </div>  
                  
                  <div class="field col-12 md:col-6">
                    <label for="beaconMacId">Beacon Mac ID</label>
                    <InputText
                      id="beaconMacId"
                      type="text"
                      v-model.trim="product.beaconMacId"
                      required="true"
                      autofocus
                    />
                  </div>

                  <div class="field col-12 md:col-2">
                    <label for="beaconMajor">Beacon Major</label>
                    <InputText
                      id="beaconMajor"
                      type="text"
                      v-model.trim="product.beaconMajor"
                      required="true"
                      autofocus
                    />
                  </div>

                  <div class="field col-12 md:col-2">
                    <label for="beaconMinor">Beacon Minor</label>
                    <InputText
                      id="beaconMinor"
                      type="text"
                      v-model.trim="product.beaconMinor"
                      required="true"
                      autofocus
                    />
                  </div>

                  <div class="field col-12 md:col-2">
                    <label for="beaconRssi">Beacon RSSI</label>
                    <InputText
                      id="beaconRssi"
                      type="text"
                      v-model.trim="product.beaconRssi"
                      required="true"
                      autofocus
                    />
                  </div>              
                  
                  <div class="field col-12 md:col-3">
                    <label for="beaconProximity">Beacon Proximity</label>
                    <InputText
                      id="beaconProximity"
                      type="text"
                      v-model.trim="product.beaconProximity"
                      required="true"
                      autofocus
                    />
                  </div>

                  <div class="field col-12 md:col-3">
                    <label for="beacontXPower">Vehicle</label>
                    <Dropdown
                      id="status"
                      v-model="selectedvehicle"
                      :options="vehicle_dropdown"
                      :value="vehicle_dropdown.id"
                      optionLabel="name"
                      filter
                      :class="{ 'p-invalid': submitted && !selectedvehicle }"
                      required="true"
                    ></Dropdown>                    
                  </div>

                  <!-- <div class="field col-12 md:col-3">
                    <label for="beacontXPower">User</label>
                    <Dropdown
                      id="status"
                      v-model="selecteduser"
                      :options="users_dropdown"
                      :value="users_dropdown.id"
                      optionLabel="name"
                      :class="{ 'p-invalid': submitted && !selectuser }"
                      required="true"
                      filter
                    ></Dropdown>                   
                  </div> -->

                  <div class="field col-12 md:col-3">
                    <label for="beacontXPower">Beacon Power</label>
                    <InputText
                      id="beacontXPower"
                      type="text"
                      v-model.trim="product.beacontXPower"
                      required="true"
                      autofocus
                    />
                  </div>
                
                </div>
              </div>
            </div>
            
            <div class="col-12 md:col-6">
              <Button
                v-if="product._id"
                style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
                label="UPDATE"
                icon="pi pi-check"
                class="p-button mr-1 mb-1"
                @click="adduser"
              ></Button>
              <Button
                v-else
                style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
                label="ADD123"
                icon="pi pi-check"
                class="p-button mr-1 mb-1"
                @click="adduser"
              ></Button>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
              <Button
                style="background-color: #349CE4; border: 1px solid #349CE4;"
                label="Cancel"
                icon="pi pi-times"
                class="p-button mr-1 mb-1"
                @click="reset"
              ></Button>
            </div>
          </Sidebar>
  
          <Dialog
            v-model:visible="productDialog_old"
            :style="{ width: '450px', width: '450px' }"
            header="Year Details"
            :modal="true"
            class="p-fluid"
          >
            <div class="grid">
              <div class="col-12 md:col-12">
                <div class="field">
                  <!-- <img
              :src="'images/product/shoes.jpg'"
              :alt="product.image"
              width="150"
              class="mt-0 mx-auto mb-5 block shadow-2"
            /> -->
                </div>
                <div class="field">
                  <label for="enrollmenT_YEAR"
                    >Enrollement Year <i style="color: green">(eg.2022)</i></label
                  >
                  <InputText
                    id="enrollmenT_YEAR"
                    v-model.trim="product.enrollmenT_YEAR"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid': submitted && !product.enrollmenT_YEAR,
                    }"
                  />
                </div>
                <div class="field">
                  <label for="exaM_YEAR"
                    >Exam Year <i style="color: green">(eg.2022-23)</i></label
                  >
                  <InputText
                    id="exaM_YEAR"
                    v-model.trim="product.exaM_YEAR"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.exaM_YEAR }"
                  />
                  <!-- <small class="p-invalid" v-if="submitted && !product.name"
                    >Name is required.</small
                  > -->
                </div>
               </div>
              <div class="col-12 md:col-6">
               </div>
              <div class="col-12 md:col-6">
                <Button
                  label="Cancel"
                  icon="pi pi-times"
                  class="p-button-danger mr-1 mb-1"
                  @click="productDialog = false"
                />
              </div>
            </div>
          </Dialog>
  
          <Dialog
            v-model:visible="deleteProductDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="flex align-items-center justify-content-center">
              <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
              />
              <span v-if="product"
                >Are you sure you want to delete <b>{{ product.name }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteProductDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deletegroup"
              />
            </template>
          </Dialog>
  
          <Dialog
            v-model:visible="deleteProductsDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="flex align-items-center justify-content-center">
              <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
              />
              <span v-if="product"
                >Are you sure you want to delete the selected products?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteProductsDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteSelectedProducts"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { FilterMatchMode } from "primevue/api";
  import ProductService from "../service/ProductService";
  import BreadcrumbService from "../service/BreadcrumbService";
  import JsonExcel from "vue-json-excel";
  import { GoogleMap, Marker,MarkerCluster,InfoWindow,GMapMarker,Polyline } from "vue3-google-map";
  import apis from "@/apis";
  import axios from "axios";
  
  export default {
    data() {
      return {
        status_dropdown: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      search_status: "",
      // selectedstatus:"",
      vehicle_search:"",
      selectedvehicle:{ name: "", id: "" },
      vehicle_dropdown:[],
      selecteduser:{ name: "", id: "" },
      users_dropdown:[],

      // search_status: null,
        start_point : {},
        end_point : {},
        markers: [],
        flightPath : {
                path:[],
                geodesic: true,
                strokeColor: "blue",
                strokeOpacity: 0.5,
                strokeWeight: 5,
              },

        client_id_dropdown: [],
      client_id_search:'',
        user_key:"",
        start:'',
        end:'',
        place_details:'',
        end_place_details:'',
        searchme:'',
        name:'',
        page_no:1,
        isLoading: false,
        isLoadingModel: false,
        loading: false,
        fullPage: true,
        file_attachment: "",

        pick_dropdown: [],
        end_pick_dropdown: [],
        pick_search:'',
        end_pick_search:'',

        user_type_dropdown: [{name: 'School', code: 'School'},{name: 'Industry', code: 'Industry'},{name: 'Other', code: 'Other'}],
        user_type_search:'',


        groupdropdownItems: [{ name: "School", value: "School" },
                             {name: "Industry", value: "Industry"},
                             {name: "Other", value: "Other"}
                            ],
        selectgroupstatus:{name:"", value:""},

        // dropdownItems: [
        //   { name: "Active", value: "Active" },
        //   { name: "InActive", value: "InActive" },
        //   { name: "Deleted", value: "Deleted" },
        // ],
        selectedstatus: { name: "", value: "" },


        products: null,
        productDialog: false,
        map_productDialog: false,
        deleteProductDialog: false,
        deleteProductsDialog: false,
        lazyParams: {},
        product: {},
        selectedProducts: null,
        filters: {},
        offset: 1,
        
        
        limit: 10,
        columns: [],
        head: [
          "Data Usages",
          "Network Connectivity",
          "Students",
          "Teachers",
          "Student Registration",
          "News Master",
          "Government Panel",
          "Feedback Master",
          "User Queries",
          "Schemes Master",
          "Notice Master",
          "Subject Master",
          "Teacher Schedule Master",
          "Teacher Schedule DE Master",
          "Query Types Master",
          "Sub Query Types Master",
          "Admin Users",
          "Application Roles",
          "Departments",
          "Cast Master",
          "Year Master",
          "District Master",
          "Student Attendance",
          "Student Document",
          "Teachers",
          "Radical ids",
          "Subject Topics",
          "Query Comments",
          "Student Submit Answers",
          "Mock Tests",
          "Mock Test Papers",
          "Mock Test Results",
          "Video",
          "Syllabus",
          "Course",
        ],
        pageno: 1,
        submitted: false,
        totalRecords: 0,
        id: "",
        statuses: [
          { label: "INSTOCK", value: "instock" },
          { label: "LOWSTOCK", value: "lowstock" },
          { label: "OUTOFSTOCK", value: "outofstock" },
        ],
        BreadcrumbService : null,
        breadcrumbHome: {},
        breadcrumbItems: [],
      };
    },
    productService: null,
    
    async created() {
      this.productService = new ProductService();
      this.initFilters();
      this.user_key=localStorage.getItem("user_key");
      this.get_client_list();
      this.get_vehicle_list();
      this.get_users_list();

      // var userlogged= localStorage.getItem("id");
      // var user = this.users_dropdown.find(user => user.id === userlogged);
      //   if (user) {
      //     this.selecteduser.id = user.id;
      //     this.selecteduser.name = user.name;
      //   }

      this.BreadcrumbService = new BreadcrumbService();
      let Breadcrum_data = this.BreadcrumbService.vehicledevicemapping()
      this.breadcrumbHome=Breadcrum_data.home;
      this.breadcrumbItems=Breadcrum_data.items;
      
    },
    async mounted() {
      // this.productService.getProducts().then(data => this.products = data);
      this.id = this.$route.params.id;
  
      this.lazyParams = {
        first: 0,
        rows: this.limit,
        sortField: null,
        sortOrder: null,
        filters: this.filters,
      };
      if (this.totalRecords == 0) {
        await this.get_count();
      }
      await this.get_list();
      
      //alert(this.id);
    },
    watch: {
     async $route() {
        this.products = [];
        this.columns = [];
        this.totalRecords = 0;
        this.id = this.$route.params.id;
        if (this.id) {
          await this.get_count();
          this.get_list();
        }
      },
    },
    methods: {
      get_location()
      { 
        this.place_details='';
        var data = { PlaceId:this.pick_search.value};
        var promise = apis.geocodelocationdetails(data);
        promise.then((response) => {
          if (response.data.result) 
          {
            this.place_details=response.data.result[0];
          }
          
          
        });

      },
       dropdown_list(search)
      { 
       var data = { search:search.value};
        var promise = apis.geocodelats(data);
        promise.then((response) => {
          this.pick_dropdown=[];
          var temp=response.data.result;
          for (let a = 0; a < temp.length; a++) {
            this.pick_dropdown.push( { name: temp[a].Text, value: temp[a].PlaceId });
            
          }
        });
      },
      end_get_location()
      { 
        this.end_place_details='';
        var data = { PlaceId:this.end_pick_search.value};
        var promise = apis.geocodelocationdetails(data);
        promise.then((response) => {
          if (response.data.result) 
          {
            this.end_place_details=response.data.result[0];
          }
          
          
        });

      },
       end_dropdown_list(search)
      { 
       var data = { search:search.value};
        var promise = apis.geocodelats(data);
        promise.then((response) => {
          this.end_pick_dropdown=[];
          var temp=response.data.result;
          for (let a = 0; a < temp.length; a++) {
            this.end_pick_dropdown.push( { name: temp[a].Text, value: temp[a].PlaceId });
            
          }
        });
      },
     
             isNumber(evt) {  
        const charCode = evt.which ? evt.which : evt.keyCode;  
        if (  
          charCode > 31 &&  
          (charCode < 48 || charCode > 57) &&  
          charCode !== 46  
        ) {  
          evt.preventDefault();  
        }  
      },  
  
      async search(count)
      { if (count==2) 
        {
          this.name='';
          this.user_type_search='';
          this.client_id_search='';
          this.search_status= "";
          this.vehicle_search="";
        }
        if(this.name!='' && this.name.length>100)
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Valid Mobile Number",
          life: 3000,
        });
        return false;
        }
        await this.get_list();
        await this.get_count();
      },
      async view_Map(product)
      { 
        this.start_point= {};
        this.end_point  = {};
        this.markers    = [];
        var data        = [];
        if(product.pickup_point && product.end_point)
        {
          this.start_point={lat:parseFloat(product.pickup_point.lat) , lng:parseFloat(product.pickup_point.lng)};
          data.push({lat:parseFloat(product.pickup_point.lat) , lng:parseFloat(product.pickup_point.lng)});

          this.end_point=  {lat:parseFloat(product.end_point.lat)    , lng:parseFloat(product.end_point.lng   )};
         
        }
        else
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Route Start Or End Point Not Found. Please Edit Route",
          life: 3000,
          });
          return false;
        }

        if (product.stops_details.length>0) 
        {   var stops_data=[];
            for (let x = 0; x < product.stops_details.length; x++) 
              {   
                stops_data.push({lat: parseFloat(product.stops_details[x].location.lat) , lng:parseFloat(product.stops_details[x].location.lng),'stop_name':product.stops_details[x].stop_name});
                data.push({lat: parseFloat(product.stops_details[x].location.lat) , lng:parseFloat(product.stops_details[x].location.lng),'stop_name':product.stops_details[x].stop_name});
              }
                this.markers=stops_data;
              
        }
        if(product.pickup_point && product.end_point)
        {
          data.push({lat:parseFloat(product.end_point.lat)    , lng:parseFloat(product.end_point.lng   )});
        }     
              
            
            this.flightPath = {path:data}
        
        

        this.map_productDialog = true;
          
      },
      async viewProduct(product)
      {
  
        // var data=[product]
        console.log(JSON.stringify(product));
        await localStorage.setItem('savegroupdata',JSON.stringify(product));
        this.$router.push({name:"groupProfile"});
      },
      //a simple date formatting function
      dateFormat(inputDate, info) {},
      handleFileUpload() {
        this.file_attachment = this.$refs.file_attachment.files[0];
  
        //alert(this.$refs.file_attachment.files[0].name);
      },
      get_time(date)
      {
        const now = new Date(date);
        const currentTimeInMillis = now.getTime();
        return currentTimeInMillis;
      },
      async onPage(event) {
        this.lazyParams = event;
        this.page_no = event.page + 1;
        this.limit = event.rows;
        // console.log(event);
      //  await this.get_count();
        if (this.totalRecords > 0) {
          this.get_list();
        }
      },
      get_count: function () {
        var status='';
        if(this.search_status.value!='')
        {
          status=this.search_status.value;
        }
        var vehicle='';
        if(this.vehicle_search.id!='')
        {
          vehicle=this.vehicle_search.id;
        }
        var data = {          
          count: true,
          status:status,
          vehicle_id:vehicle        
        };
        this.loading = true;
        var promise = apis.VehicleDeviceMappingList(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.totalRecords = response.data.data;
          //alert(this.totalRecords);
        });
  
        console.log(data);
      },
      get_list: function () {
        var status='';
        if(this.search_status.value!='')
        {
          status=this.search_status.value;
        }
        var vehicle='';
        if(this.vehicle_search.id!='')
        {
          vehicle=this.vehicle_search.id;
        }
        console.log("vehicle id",vehicle);
        var data = {
          limit: this.limit,
          page_no: this.page_no,
          count: false,
          status:status,
          vehicle_id:vehicle        
        };
        console.log(data);
        this.loading = true;
        var promise = apis.VehicleDeviceMappingList(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.products = response.data.data;
          console.log(this.products[0]);
          if (this.columns.length == 0) {
            if (this.products.length > 0) {
              this.columns = Object.keys(this.products[0]);
            }
          }
        });
  
        console.log(data);
      },
      formatCurrency(value) {
        if (value)
          return value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        return;
      },
      openNew() {
        this.product = {};
        this.submitted = false;
        this.productDialog = true;
      },
      hideDialog() {
        this.productDialog = false;
        this.submitted = false;
      },
      time_converter(data)
      {
        const date = new Date(data); // create a Date object with the given UTC date and time 
        const options = { hour: 'numeric', minute: '2-digit', hour12: true }; // define the options for the time format
        const time = date.toLocaleString('en-US', options); // convert the date and time to a string in the specified format and time zone
        return time;
      },
      get_client_list()
    { 
      var data = { count: false};
      var promise = apis.getclientist(data);
        promise.then((response) => {
          if(response.data.data){
          response.data.data
            .filter(item => item.client_name)
            .map(item => this.client_id_dropdown.push({ name: item.client_name, value: item._id }));
          }
        });
    },
      to_timestamp(data)
      {
    
        if (data) {
          const timeString = data;
        const date = new Date(`01/01/2000 ${timeString}`);
        const timestamp = Math.floor(date.getTime() / 1000);
        return timestamp;
        }
        else
        {
          return '';
        }
        
        
      },
      async adduser() {
        this.submitted = true;
        if (!this.selectedstatus.value) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Device Status",
            life: 3000,
          });
          return false;
        }
        // if (!this.product.beaconUUID) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Please Enter Beacon UUID",
        //     life: 3000,
        //   });
        //   return false;
        // }    
        
        if (!this.product.beaconIndentifier) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Beacon Identifier",
            life: 3000,
          });
          return false;
        }

        if (this.selectedvehicle.length==0) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Vehicle",
            life: 3000,
          });
          return false;
        }

        if (this.selecteduser.length==0) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select User",
            life: 3000,
          });
          return false;
        }

        // if (!this.product.beaconAccuracy) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Please Enter Beacon Accuracy",
        //     life: 3000,
        //   });
        //   return false;
        // }

        // if (!this.product.beaconProximity) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Please Enter Beacon Proximity",
        //     life: 3000,
        //   });
        //   return false;
        // }

        // if (!this.product.beaconMajor) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Please Enter Beacon Major",
        //     life: 3000,
        //   });
        //   return false;
        // }

        // if (!this.product.beaconMinor) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Please Enter Beacon Minor",
        //     life: 3000,
        //   });
        //   return false;
        // }

        // if (!this.product.beaconRssi) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Please Enter Beacon RSSI",
        //     life: 3000,
        //   });
        //   return false;
        // }

        // if (!this.product.beaconMacId) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Please Enter Beacon Mac ID",
        //     life: 3000,
        //   });
        //   return false;
        // }

        // if (!this.product.beacontXPower) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Please Enter Beacon X-Power",
        //     life: 3000,
        //   });
        //   return false;
        // }

        var status='';
        if(this.selectedstatus!='')
        {
          status=this.selectedstatus.value;
        }
        console.log("status",status);

        //edit
        if (this.product._id) {
          // alert("edit");
            var data = {
              "_id":this.product._id,
              "vehicle_id": this.selectedvehicle.id,
              "user_id": this.selecteduser.id,
              "status":status,
              "created_at": this.product.created_at,
              "beaconIndentifier": this.product.beaconIndentifier,
              "beaconMacId": this.product.beaconMacId,
              "beaconUUID": this.product.beaconUUID,
              "beaconAccuracy": this.product.beaconAccuracy,
              "beaconMajor": this.product.beaconMajor,
              "beaconMinor": this.product.beaconMinor,
              "beaconProximity": this.product.beaconProximity,
              "beaconRssi": this.product.beaconRssi,
              "beacontXPower": this.product.beacontXPower
            };
         
          this.isLoadingModel = true;
          console.log(data);
          // return false;
          var promise = apis.EditVehicleDeviceMapp(data);
          promise
            .then((responseapi) => {
              this.$swal(responseapi.data.message);
              this.isLoadingModel = false;
              this.productDialog = false;
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
        //add-----------------------------------------------------------------------------------------------------------------
        else {
          // alert("add");
          var data1 = {
            // "_id":this.product._id,
            "vehicle_id": this.selectedvehicle.id,
            "user_id": this.selecteduser.id,
            "status":status,
            "beaconIndentifier": this.product.beaconIndentifier,
            "beaconMacId": this.product.beaconMacId,
            "beaconUUID": this.product.beaconUUID,
            "beaconAccuracy": this.product.beaconAccuracy,
            "beaconMajor": this.product.beaconMajor,
            "beaconMinor": this.product.beaconMinor,
            "beaconProximity": this.product.beaconProximity,
            "beaconRssi": this.product.beaconRssi,
            "beacontXPower": this.product.beacontXPower
          };
          this.isLoadingModel = true;
          // console.log(data1);
          // return false;
          var promises = apis.AddVehicleDeviceMapp(data1);
          promises
            .then((response) => {
              this.isLoadingModel = false;
              this.productDialog = false;
              this.$swal(response.data.message);
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
  
        this.selectstatus = { name: "", value: "" };
        this.selectgroupstatus={name:"",value:""};
        this.pick_dropdown=[];
        this.end_pick_dropdown=[];
        this.place_details='';
        this.end_place_details='';
      },
      saveProduct() {
        this.submitted = true;
        if (this.product.name.trim()) {
          if (this.product.id) {
            this.product.inventoryStatus = this.product.inventoryStatus.value
              ? this.product.inventoryStatus.value
              : this.product.inventoryStatus;
            this.products[this.findIndexById(this.product.id)] = this.product;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Updated",
              life: 3000,
            });
          } else {
            this.product.id = this.createId();
            this.product.code = this.createId();
            this.product.image = "product-placeholder.svg";
            this.product.inventoryStatus = this.product.inventoryStatus
              ? this.product.inventoryStatus.value
              : "INSTOCK";
            this.products.push(this.product);
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Created",
              life: 3000,
            });
          }
          this.productDialog = false;
          this.product = {};
        }
      },

      get_vehicle_list() {  
        var client_id=localStorage.getItem("client_id");      
        var data = {
          limit: 1000,
          page_no: 1,
          count: false,
        };
        this.loading = true;
        var promise = apis.vehiclelist(data);
        promise.then((response) => {
          this.loading = false;
          var temp=response.data.data;  
          this.vehicle_dropdown = response.data.data.map(item => ({
            id: item._id,
            name: item.registration_number
          }));          
          console.log("vehicle list",this.vehicle_dropdown);    
        });
      },

      get_users_list() {  
        console.log("users list");
          var client_id=localStorage.getItem("client_id");      
          var data = {
            limit: 1000,
            page_no: 1,
            count: false,
          };
          this.loading = true;
          var promise = apis.userlist(data);
          promise.then((response) => {
            this.loading = false;
            var temp=response.data.data;  
            this.users_dropdown = response.data.data.map(item => ({
              id: item._id,
              name: item.first_name + " "+ item.last_name
            }));          
            console.log("users list",this.users_dropdown);    
          });
      },

      reset()
      {
        this.product={};
        this.selecteduser={ name: "", id: "" },
        this.selectedvehicle={ name: "", id: "" },
        this.selectedstatus= { name: "", value: "" };
        this.productDialog = false;
      },

      format_time(data)
      {
        if(data) 
        {
          const date = new Date(data);
          return date;
        }
        else
        {
          return '';
        }

      },
      format_time2(data)
      {
        const timeString = data; // the time string to convert
        const defaultDateString = new Date().toDateString(); // use the current date as the default date
        const dateTimeString = `${defaultDateString} ${timeString}`; // combine the default date and the time string
        const date = new Date(dateTimeString); // create a Date object from the complete date and time string
        return date;

      },
      
      editProduct(product) {
        this.product = { ...product };
        this.productDialog = true;
        console.log("Productsssss",this.product);
        
        this.selectedstatus.value = this.product.status;
        this.selectedstatus.name = this.product.status;
  
        // this.selectedvehicle.id = this.product.vehicle_id;
        // this.selectedvehicle.name = this.product.vehicle_id;

        // for (let user = 0; user < this.users_dropdown.length; user++) 
        // {
        //   if (this.product.created_by == this.users_dropdown[user]['id']) {
        //     this.selecteduser.id = this.product.created_by;
        //     this.selecteduser.name = this.users_dropdown[user]['name'];
            
        //   }  
        // }
        var vehicle = this.vehicle_dropdown.find(user => user.id === this.product.vehicle_id);
        if (vehicle) {
          this.selectedvehicle.id = vehicle.id;
          this.selectedvehicle.name = vehicle.name;
        }
        var user = this.users_dropdown.find(user => user.id === this.product.created_by);
        if (user) {
          this.selecteduser.id = user.id;
          this.selecteduser.name = user.name;
        }
        // this.selecteduser.name = this.product.created_by;
        
      },
      confirmDeleteProduct(product) {
        this.product = product;
        this.deleteProductDialog = true;
      },
      deleteProduct() {
        this.products = this.products.filter((val) => val.id !== this.product.id);
        this.deleteProductDialog = false;
        this.product = {};
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Product Deleted",
          life: 3000,
        });
      },
  
      deletegroup() {
        if (this.product._id) {
          var data = {
            _id: this.product._id,
          };
          this.isLoadingModel = true;
          var promise = apis.DeleteVehicleDeviceMapp(data);
          promise.then((responseapi) => {
            this.isLoadingModel = false;
            if (responseapi.data.status == true) {
              // this.hideDialog1();
              this.deleteProductDialog = false;
              this.$swal(responseapi.data.message);
              this.get_list();
              this.get_count();
            } else {
              this.$swal("error to Delete Record");
            }
          });
        }
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.products.length; i++) {
          if (this.products[i].id === id) {
            index = i;
            break;
          }
        }
        return index;
      },
      createId() {
        let id = "";
        var chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      
    async  exportCSV() {
        this.limit=this.totalRecords;
        this.get_list();
       await this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteProductsDialog = true;
      },
      deleteSelectedProducts() {
        this.products = this.products.filter(
          (val) => !this.selectedProducts.includes(val)
        );
        this.deleteProductsDialog = false;
        this.selectedProducts = null;
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Products Deleted",
          life: 3000,
        });
      },
      initFilters() {
        this.filters = {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
      },
    },
    components: {downloadExcel: JsonExcel,GoogleMap, Marker,MarkerCluster,InfoWindow,GMapMarker,Polyline},
  };
  </script>
  
  <style scoped lang="scss">
  @import "../assets/demo/badges.scss";
  </style>
  